import { render, staticRenderFns } from "./CHD_case.vue?vue&type=template&id=45721496&scoped=true"
import script from "./CHD_case.vue?vue&type=script&lang=js"
export * from "./CHD_case.vue?vue&type=script&lang=js"
import style0 from "./CHD_case.vue?vue&type=style&index=0&id=45721496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45721496",
  null
  
)

export default component.exports